import {css} from 'styled-components';

export default css`
  width: 100%;
  
  .ant-btn {
    margin-top: 10px;
  }
`;
